import { type FieldValues, useController } from 'react-hook-form';
import { type DatePickerControllerProps } from './types';
import { DatePicker } from '.';

export const DatePickerController = <T extends FieldValues>({
  name,
  control,
  rules,
  defaultValue,
  shouldUnregister,
  ...rest
}: DatePickerControllerProps<T>): React.ReactElement => {
  const { field } = useController({
    name,
    control,
    rules,
    defaultValue,
    shouldUnregister,
  });

  return <DatePicker value={field.value} onChange={field.onChange} {...rest} />;
};
